
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center max-w-md px-4">
        <h1 className="text-6xl font-bold text-gray-800 mb-6">404</h1>
        <p className="text-xl text-gray-600 mb-8">
          We couldn't find the page you're looking for
        </p>
        <div className="flex justify-center">
          <Button asChild className="flex items-center gap-2">
            <Link to="/dashboard">
              <Home size={18} />
              <span>Return to Dashboard</span>
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
